export default __webpack_public_path__ + "7c896b220601da742cafdc90f4c31ea9.svg";